export default __webpack_public_path__ + "static/media/cloudy.5aff0f18.png";